import { addOrReplaceKey } from 'state/utils/collection';

import type { Action } from '../actions';
import type { BdrSettlementCalendarsBlackoutDatesState } from './settlementDateCalendars.model';
import { initialBdrSettlementCalendarsBlackoutDatesState } from './settlementDateCalendars.model';

export function SettlementDateCalendarsReducer(
  state: BdrSettlementCalendarsBlackoutDatesState = initialBdrSettlementCalendarsBlackoutDatesState,
  action: Action,
): BdrSettlementCalendarsBlackoutDatesState {
  switch (action.type) {
    case 'SETTLEMENT_CALENDARS_BLACKOUT_DATES_RECEIVED':
      return addOrReplaceKey(state, action.currencyCode, action.holidays);
    default:
      return state;
  }
}
